import { render, staticRenderFns } from "./faqEditor.vue?vue&type=template&id=5da3ecdf&scoped=true&"
import script from "./faqEditor.vue?vue&type=script&lang=js&"
export * from "./faqEditor.vue?vue&type=script&lang=js&"
import style0 from "./faqEditor.vue?vue&type=style&index=0&id=5da3ecdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3ecdf",
  null
  
)

export default component.exports